import apiRoles from '../services/roles.api';
import apiPermissions from '../services/permissions.api';

export default {
  namespaced: true,
  state: {
    roles: [],
    permissions: [],
  },
  mutations: {
    setRoles(state, roles) {
      state.roles = roles;
    },
    setPermissions(state, permissions) {
      state.permissions = permissions;
    },
    saveRole(state, role) {
      state.roles.push(role);
    },
    updateRole(state, role) {
      const roles = state.roles.map((el) =>
        el.roleId === role.roleId ? { ...el, name: role.name, description: role.description, internal: role.internal } : el
      );

      state.roles = roles;
    },
  },
  actions: {
    async getRoles({ commit }) {
      const roles = await apiRoles.getRoles();
      commit('setRoles', roles);
    },
    async getPermissions({ commit }) {
      const permissions = await apiPermissions.getPermissions();
      commit('setPermissions', permissions);
    },
    async saveRole({ commit }, role) {
      const savedRole = await apiRoles.saveRole(role);
      commit('saveRole', savedRole);
    },
    async updateRole({ commit }, role) {
      const updatedRole = await apiRoles.updateRole(role);

      commit('updateRole', updatedRole);
    },
  },
}